export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAF0lEQVR4nGNgYGBg+M/AwMDAxAADCBYAGUEBBEzbeRwAAAAASUVORK5CYII="